import { LogisticaGuiaEstado } from "@pcgerente-node/pcg-comun";
import { CSSProperties, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import img1 from "../../assets/img/BANNER.jpg";
import img2 from "../../assets/img/BANNER2.jpg";
import img3 from "../../assets/img/BANNER3.jpg";
import { buscarUsuarioPorId } from "../../redux/actions/actionAuth";
import { getGuiasRecientes } from "../../redux/actions/actionsHome";
import { RootState, useAppDispatch } from "../../redux/store";

const Home = () => {
    const GuiasRecientesStore = useSelector((state: RootState) => state.home.guiasRecientesHome)
    const usuarioVM = useSelector((state: RootState) => state.auth.usuarioActual)

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    useEffect(() =>{
        dispatch(buscarUsuarioPorId())
    }, [])
    
    const usuario = usuarioVM._ItemActivo
    useEffect(() => {
        if(usuario?.idConductor){
            navigate("/home/liquidarRuta")
        }
        if(usuario?.id){
            buscarGuiasRecientes(usuario.id)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[usuarioVM])

    function buscarGuiasRecientes(idUsuario: number ) {
        dispatch(getGuiasRecientes(idUsuario))
    }

    const estiloGuiasRecientes: CSSProperties = {
        color: "white",
        padding: "0 2px"
    }

    return(
        <div id="content" className="main-content">
            <div className="layout-px-spacing">
            <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                <ol className="carousel-indicators">
                    <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active m"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                </ol>
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img className="d-block w-100" src={img1} alt="First slide"/>
                    </div>
                    <div className="carousel-item">
                        <img className="d-block w-100" src={img2} alt="Second slide"/>
                    </div>
                    <div className="carousel-item">
                        <img className="d-block w-100" src={img3} alt="Third slide"/>
                    </div>
                </div>
                <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Anterior</span>
                </a>
                <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Siguiente</span>
                </a>
            </div>
           
                
                <div className="row layout-top-spacing">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                        <div className="widget widget-table-two p-2" >

                            <div className="widget-heading d-flex justify-content-between align-items-center m-2">
                                <h5 className="d-flex m-0">Guías Recientes</h5>
                                <button className="btn btn-success" onClick={()=> buscarGuiasRecientes(usuario.id)}>Volver a buscar</button>
                            </div>

                            <div className="widget-content">
                                <div className="table-responsive" >
                                    <table className="table" >
                                        <thead style={{ backgroundColor : "#304aca"}}>
                                            <tr>
                                                <th>
                                                    <div className="th-content pl-2 pr-2-" style={estiloGuiasRecientes}>Destinatario</div>                                                    
                                                </th>
                                                <th>
                                                    <div className="th-content pl-2 pr-2-" style={estiloGuiasRecientes}>Origen</div>
                                                </th>
                                                <th>
                                                    <div className="th-content pl-2 pr-2-" style={estiloGuiasRecientes}>Destino</div>
                                                </th>
                                                <th>
                                                    <div className="th-content pl-2 pr-2-" style={estiloGuiasRecientes}>Guía</div>
                                                </th>
                                               
                                                <th>
                                                    <div className="th-content pl-2 pr-2- text-center" style={estiloGuiasRecientes}>Estado</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {GuiasRecientesStore.loading === false?
                                            GuiasRecientesStore.info.length>0?
                                            GuiasRecientesStore.info.slice(0,6).map(guia => 
                                            <tr key={guia.id}>
                                                <td>
                                                    <div className="td-content pb-0">{guia.CLIENTE_DESTINATARIO?.razonSocial} </div>
                                                </td>
                                                <td>
                                                    <div className="td-content ">{guia.CIUDAD_ORIGEN?.nombre}</div>
                                                </td>
                                                <td>
                                                    <div className="td-content ">{guia.CIUDAD_DESTINO?.nombre}</div>
                                                </td>
                                                <td>
                                                    <div className="td-content ">{`${guia.serie1}-${guia.serie2}-${guia.numeroDocumento}`}</div>
                                                </td>
                                            
                                                <td>
                                                    {guia.estado === LogisticaGuiaEstado.Planta?
                                                    <div className="td-content text-center">
                                                        <span className="badge badge-warning">En planta</span>
                                                    </div>
                                                    :guia.estado === LogisticaGuiaEstado.Viaje?
                                                    <div className="td-content text-center">
                                                        <span className="badge badge-primary">En viaje</span>
                                                    </div>
                                                    : guia.estado === LogisticaGuiaEstado.RecibidoEnBodegaTransito?
                                                    <div className="td-content text-center">
                                                        <span className="badge badge-dark">En bodega</span>
                                                    </div>
                                                    : guia.estado === LogisticaGuiaEstado.Ruta?
                                                    <div className="td-content text-center">
                                                        <span className="badge badge-info">En ruta</span>
                                                    </div>
                                                    :guia.estado === LogisticaGuiaEstado.Recibido?
                                                    <div className="td-content text-center">
                                                        <span className="badge badge-secondary">Recibido</span>
                                                    </div>
                                                    :guia.estado === LogisticaGuiaEstado.Entregada?
                                                    <div className="td-content text-center">
                                                        <span className="badge badge-success">Entregada</span>
                                                    </div>
                                                    :guia.estado === LogisticaGuiaEstado.Anulado?
                                                    <div className="td-content text-center">
                                                        <span className="badge badge-danger">Anulado</span>
                                                    </div>
                                                    :
                                                    <></>
                                                }
                                                </td>
                                            </tr>
                                                )
                                                : //Por si no hay contenido
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td className="text-center">No hay guias recientes</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                        ://Por si el estado de redux aún está cargando la información
                                            <tr style={{height: "22rem"}}>
                                                <td></td>
                                                <td></td>
                                                <td className="text-center">cargando..</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>

            </div>
          
        </div>
    )
}


export default Home